import React, {Component} from 'react';
import {formatAmount} from "../lib/payment-utils";
import {moment} from "../lib/ext-refs";
import {getPtDescriptionByCode} from "../lib/utils";

/**
 * Renders the payment transaction list table.
 * Each row in the table is a payment item.
 * We will search in the list of payments to filter out groups
 * that are selected and has a payment amount > 0 and for each group
 * filter our items that has a payment amount > 0.
 * expected properties:
 *  data
 *  config
 */
class ReviewPaymentTransactionList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {data, config, hidePaymentType, hideCnvFee} = this.props,
            {payments} = data,
            {messages} = config;

        // check if we have due dates
        const hasDueDates = payments.find(p => p.liability && p.liability.dueDate);
        const hasDueAmounts = payments.find(p => p.liability && p.liability.amountDue);

        const XOTP_DATE_FORMAT = 'MMDDYYYY';
        const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
        let paymentBundleEntries = "";
        const paymentEntries = payments.map((payment) => {
            const {header} = payment;
            const liability = payment.liability || {};
            
            let hasPaymentBundle = false;
            if(payment.bundle && payment.bundle.paymentItems){
                if(payment.bundle.paymentItems.length > 0){
                paymentBundleEntries = payment.bundle.paymentItems.map((item,index) => {
                    hasPaymentBundle =true;
                    if(!item.selected){
                        return;
                    }
                    return (
                        <tr key={"bundleComponents"+item.index+item.label}>
                            <td className="account-num-col">{item.label}</td>
                            <td colSpan="2" className="amount-due-col dark-grey-text text-right">{
                                    formatAmount(item.paymentAmount || 0)
                                }</td>
                            <td className="payment-amount-col text-right"></td>
                            <td className="payment-date-col text-right"></td>
                        </tr>
                    );
                });
            }else{
                if(payment.bundle.paymentItems){
                    let item = payment.bundle.paymentItems;
                    if(item.selected){
                        hasPaymentBundle =true;
                        paymentBundleEntries = (<tr key={"bundleComponents"+item.label}>
                        <td className="account-num-col">{item.label}</td>
                        <td colSpan="2" className="amount-due-col dark-grey-text text-right">{
                                formatAmount(item.paymentAmount || 0)
                            }</td>
                        <td className="payment-amount-col text-right"></td>
                        <td className="payment-date-col text-right"></td>
                    </tr>)
                    }
                    
                }
                    
            }
        }
            
  
            return (
                <React.Fragment key={"paymentsIndex_"+payment.index}>
                <tr key={payment.index}>
                    <td className="account-num-col">{header.accountNumber}</td>
                    {!hidePaymentType &&
                    <td className="payment-type-col text-center">
                        {getPtDescriptionByCode(config.paymentConfig, header.paymentTypeCode)}
                    </td>
                    }
                    {hasDueAmounts && (
                        <td className="amount-due-col dark-grey-text text-right">{
                            formatAmount(liability.amountDue || 0)
                        }</td>
                    )}
                    {hasDueDates && (
                        <td className="due-date-col dark-grey-text">{
                            liability.dueDate
                                ? moment(liability.dueDate, XOTP_DATE_FORMAT).format(DATE_DISPLAY_FORMAT)
                                : ''
                        }</td>
                    )}
                    <td className="payment-amount-col text-right">{
                        formatAmount(header.paymentAmount)
                    }</td>
                    <td className="payment-date-col text-right">{
                        header.effectiveDate && header.effectiveDate.dateStr
                            ? moment(header.effectiveDate.dateStr, XOTP_DATE_FORMAT).format(DATE_DISPLAY_FORMAT)
                            : ''
                    }
                    </td>
                    {!hideCnvFee &&
                    <td className="payment-convenienceFee-col text-right">
                        {formatAmount(header.convenienceFee || 0)}
                    </td>
                    }
                </tr>
                {hasPaymentBundle &&
                    <tr>
                        <td colSpan="7">
                            <h4 className="subsection-title">{messages["payment.components.label"]}</h4>
                            <table className="table table-review-payment table-hover table-sm-custom table-bordered-simple">
                                <tbody>
                                {paymentBundleEntries}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                }
                 
                </React.Fragment>
            );
        });
        return (
            <div className="review-components">
                <h4 className="subsection-title">{messages["opp.paymentTransactionList.title"]}</h4>
                <table className="table table-review-payment table-hover table-sm-custom table-bordered-simple">
                    <thead>
                    <tr>
                        <th className="account-num-col dark-grey-text">{messages["payment.accountNumber.label"]}</th>
                        {!hidePaymentType && (
                            <th className="payment-type-col dark-grey-text text-center">{messages["payment.type.label"]}</th>
                        )}
                        {hasDueAmounts && (
                            <th className="amount-due-col dark-grey-text text-right">{messages["payment.amountDue.label"]}</th>
                        )}
                        {hasDueDates && (
                            <th className="due-date-col dark-grey-text">{messages["payment.dueDate.label"]}</th>
                        )}
                        <th className="payment-amount-col dark-grey-text text-right">{messages["payment.amount.label"]}</th>
                        <th className="payment-date-col dark-grey-text text-right">{messages["payment.date.label"]}</th>
                        {!hideCnvFee &&
                        <th className="payment-date-col dark-grey-text text-right">{messages["payment.convenienceFee.label"]}</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {paymentEntries}
                   
                    </tbody>
                </table>
                         
               
            </div>
        );
    }
}

export default ReviewPaymentTransactionList;